<template>
  <footer
    role="footer"
    class="cac-footer"
  >
    <div class="container">
      <div class="footer-content justify-content-between">
        <div>
          <p class="d-flex">
            <button
              :class="{'active-route': isLanguageSelected('en')}"
              class="pl-0"
              @click.prevent="setSelectedLanguage('en')">English</button>
            <button
              :class="{'active-route': isLanguageSelected('es')}"
              @click.prevent="setSelectedLanguage('es')">Español</button>
          </p>
          <cac-media-icons/>
          <p v-if="showContactInfo">{{ footerContactInfoContent }}</p>
        </div>
        <p class="privacy-policy">© {{ currentYear }}. {{ $t('cac.app.all_rights_reserved') }} <a
          :href="privacyPolicyUrl"
          target="_blank">{{ privacyPolicyUrlLabel }}</a></p>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { isEmpty as _isEmpty } from "lodash";
import CacMediaIcons from "CivicActionCenterComponents/layout/CACMediaIcons.vue";
import SharedMixin from "JS/mixins/campaign/civicactioncenter/shared";
import STATE from "Constants/campaign/civicactioncenter/state";
import { i18n } from "JS/i18n";

const selectedLanguageContext = `cac/${STATE.SELECTED_LANGUAGE}`;
const privacyPolicyUrlContext = `${STATE.SCOPE_CAMPAIGN}/${
  STATE.PRIVACY_POLICY_URL
}`;

export default {
  name: "CACFooter",
  components: {
    CacMediaIcons
  },
  mixins: [SharedMixin],
  i18n,
  computed: {
    ...mapGetters({
      privacyPolicyUrl: privacyPolicyUrlContext,
      selectedLanguage: selectedLanguageContext
    }),
    ...mapState(STATE.SCOPE_CAMPAIGN, {
      footerContactInfoContent: state =>
        state[STATE.FOOTER_CONTACT_INFO_CONTENT],
      showFooterContactInfo: state => state[STATE.SHOW_FOOTER_CONTACT_INFO],
      privacyPolicyUrlLabelText: state => state.privacyPolicyUrlLabel
    }),
    showContactInfo() {
      return (
        this.isLanguageSelected("en") &&
        this.showFooterContactInfo === "1" &&
        (this.footerContactInfoContent &&
          this.footerContactInfoContent.length > 0)
      );
    },
    currentYear() {
      return new Date().getFullYear();
    },
    privacyPolicyUrlLabel() {
      return !_isEmpty(this.privacyPolicyUrlLabelText)
        ? this.privacyPolicyUrlLabelText
        : this.$t("cac.app.privacy_policy");
    }
  },
  methods: {
    ...mapActions({
      setSelectedLanguageState: selectedLanguageContext
    }),
    isLanguageSelected(lang) {
      return this.selectedLanguage === lang;
    },
    setSelectedLanguage(language) {
      this.setSelectedLanguageState(language);
      this.trackMixpanelInteract();
    }
  }
};
</script>
